import { render } from "./PageHeaderScenario.vue?vue&type=template&id=5d39b768"
import script from "./PageHeaderScenario.js?vue&type=script&lang=js"
export * from "./PageHeaderScenario.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__